import { MARKED_OPTIONS, MarkedOptions, MarkedRenderer } from 'ngx-markdown';

function markedOptionsFactory(): MarkedOptions {
  const renderer = new MarkedRenderer();

  renderer.link = ({
    href,
    title,
    text,
  }: {
    href: string;
    title?: string;
    text: string;
  }) => {
    const defaultHtml = MarkedRenderer.prototype.link.call(renderer, {
      href,
      title,
      text,
    });

    return defaultHtml.replace(
      /^<a /,
      '<a role="link" tabindex="0" target="_blank" rel="nofollow noopener noreferrer" ',
    );
  };

  return {
    renderer,
    gfm: true,
    breaks: false,
    pedantic: false,
  };
}

export const MarkdownModuleOptionsProvider = {
  provide: MARKED_OPTIONS,
  useFactory: markedOptionsFactory,
};
